/** استخراج برچسب از آبجکت/آرایه relation (source، category و ...) */
export const resolveRelationLabel = (value) => {
  if (value == null) return null;
  if (Array.isArray(value)) {
    if (!value.length) return null;
    const first = value[0];
    if (!first || typeof first !== 'object') return null;
    return first.category_name || first.name || first.type || null;
  }
  if (typeof value === 'object') {
    return value.category_name || value.name || value.type || null;
  }
  return null;
};

export const resolveSourceId = (record) =>
  record?.source_id ?? record?.source?.id ?? null;

export const resolveSourceName = (record, sourcesList = []) => {
  // رابطه‌ی leadSource در JSON لاراول به‌صورت lead_source می‌آید
  const fromRecord =
    resolveRelationLabel(record?.source) ||
    resolveRelationLabel(record?.lead_source) ||
    resolveRelationLabel(record?.leadSource);
  if (fromRecord) return fromRecord;

  const sourceId = resolveSourceId(record);
  const source = (sourcesList || []).find((s) => String(s.id) === String(sourceId));
  return source?.type || source?.name || 'تعریف نشده';
};

export const resolveCategoryId = (record) =>
  record?.category_id ?? record?.category?.id ?? null;

export const resolveCategoryName = (record, categoriesList = []) => {
  const fromRecord = resolveRelationLabel(record?.category);
  if (fromRecord) return fromRecord;

  const categoryId = resolveCategoryId(record);
  const category = (categoriesList || []).find((c) => String(c.id) === String(categoryId));
  return category?.category_name || category?.name || 'تعریف نشده';
};

export const resolveAddedById = (record) => {
  const raw = record?.added_by;
  if (!raw) return null;
  if (Array.isArray(raw)) return raw[0]?.id ?? null;
  if (typeof raw === 'object') return raw.id ?? null;
  return raw;
};

/** نام added_by — پشتیبانی از آبجکت، آرایه، id */
export const resolveAddedByName = (record, employeesList = []) => {
  const raw = record?.added_by;
  if (Array.isArray(raw) && raw.length > 0) {
    const names = raw.map((item) => item?.name).filter(Boolean);
    if (names.length) return names.join('، ');
  }
  if (raw && typeof raw === 'object' && !Array.isArray(raw) && raw.name) {
    return raw.name;
  }
  const addedById = resolveAddedById(record);
  if (addedById == null || addedById === '') return null;
  const employee = (employeesList || []).find((e) => String(e.id) === String(addedById));
  return employee?.name || null;
};

/** form-data / filters پاسخ جزئیات سرنخ یا معامله برای سلکت‌های ویرایش سریع */
export const resolveDetailFormFilters = (res) => {
  const formData = res?.['form-data'] || res?.form_data || res?.formData || null;
  const legacy = res?.filters || null;
  const src = formData || legacy;
  if (!src && !legacy) return null;

  const colleagues =
    formData?.colleagues ||
    formData?.employees ||
    legacy?.colleagues ||
    legacy?.employees ||
    legacy?.dealWatcher ||
    [];

  return {
    ...(legacy && typeof legacy === 'object' ? legacy : {}),
    ...(formData && typeof formData === 'object' ? formData : {}),
    categories: formData?.categories || legacy?.categories || [],
    sources: formData?.sources || legacy?.sources || [],
    tags: formData?.tags || legacy?.tags || [],
    colleagues,
    employees: colleagues,
    products: formData?.products || legacy?.products || [],
    dealWatcher:
      formData?.dealWatcher ||
      legacy?.dealWatcher ||
      colleagues,
    reject_reasons: formData?.reject_reasons || legacy?.reject_reasons || [],
  };
};
